/**
 * Device-local state — persisted to localStorage, never sent to Firebase.
 */

export const initialLocalState = {
  role:        '',
  team:        '',
  displayName: '',
  members:     [],
  isMaster:    false,
  scorerNum:   1,
  _lastReset:  0,
};

/** @param {typeof initialLocalState} state */
export function saveLocal(state, storage) {
  storage.set('mv_local', state);
}

/** @returns {typeof initialLocalState|null} */
export function loadLocal(storage) {
  const saved = storage.get('mv_local');
  if (!saved?.role) return null;
  return { ...initialLocalState, ...saved };
}
